// removed by extract-text-webpack-plugin
module.exports = {"tooltip":"_2SVFBuI_F9Y6EIdY0xEDwn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Realtor/RealtorContactUs/RealtorTooltip/RealtorTooltip.scss
// module id = 1724
// module chunks = 0